import ASN from './ASN';

class Member {
  constructor(data) {
    this.id = '' + data.memid;
    this.account = data['mem-account'];
    this.ASNs = data.asnlist.map(i => new ASN(i));

    // economy and region is used to keep the info of selected ASN, even though all ASNs belonging to a member may have different economy and region property
    // if current economy and region property in Member is the same as the one of the selected ASN, this structure could avoid retrieve data repeatedly
    this.economy =
      data.asnlist && data.asnlist[0] ? data.asnlist[0].economy : ''; // use the economy of the 1st asn for init
    this.economyName =
      data.asnlist && data.asnlist[0] ? data.asnlist[0].economyName : '';
    this.economyData = null;
    this.region = data.asnlist && data.asnlist[0] ? data.asnlist[0].region : ''; // use the region of the 1st asn for init
    this.regionData = null;
  }

  get economyUrl() {
    return `/CC/${this.economy}`;
  }

  get regionUrl() {
    return `/Region/${this.region}`;
  }
}

export default Member;
